import './assets/css/style.css';
import './assets/css/bootstrap.min.css';
import { Header } from './Components/Header';
import { Footer } from './Components/Footer';
import { Home } from './Components/Home';
import {About} from './Components/About';
import { Services } from './Components/Services';
import { Contact } from './Components/Contact';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Projects } from './Components/Projects';
import { ProjectDetails } from './Components/ProjectDetails';
import { Events } from './Components/Events';
import { EventDetails } from './Components/EventDetails';
import { KnowledgeCenter } from './Components/knowledgeCenter';



function App() {
  return (
          <BrowserRouter>
            <Header />
                <Routes>                  
                    <Route path='/' element={<Home />} />
                    <Route path='about' element={<About />}/>
                    <Route path='services' element={<Services />} />
                    <Route path='contact' element={<Contact />} />
                    <Route path='projects' element={<Projects />} />
                    <Route path="/projects/:slug" element={<ProjectDetails />} />
                    <Route path='events' element={<Events />}  />          
                    <Route path="/events/:slug" element={<EventDetails />} />     
                    <Route path="/knowledge-center" element={<KnowledgeCenter />} />     
                </Routes>
              <Footer />

        </BrowserRouter>
  );
}

export default App;
